/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Platforms_ExcelInputs */

const en_gc_resources_compare_platforms_excel = /** @type {(inputs: Gc_Resources_Compare_Platforms_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows, macOS and web`)
};

const zh_gc_resources_compare_platforms_excel = /** @type {(inputs: Gc_Resources_Compare_Platforms_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows、macOS 和网页`)
};

/**
* | output |
* | --- |
* | "Windows, macOS and web" |
*
* @param {Gc_Resources_Compare_Platforms_ExcelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_platforms_excel = /** @type {((inputs?: Gc_Resources_Compare_Platforms_ExcelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Platforms_ExcelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_platforms_excel(inputs)
	return zh_gc_resources_compare_platforms_excel(inputs)
});
export { gc_resources_compare_platforms_excel as "gc.resources.compare.platforms.excel" }